import type {
  AuthRepository,
  LoginCredentials,
  LoginOutcome,
} from '@core/repositories/AuthRepository';

export class LoginUseCase {
  private readonly authRepository: AuthRepository;

  constructor(authRepository: AuthRepository) {
    this.authRepository = authRepository;
  }

  execute(credentials: LoginCredentials): Promise<LoginOutcome> {
    return this.authRepository.login(credentials);
  }
}
